<h1 mat-dialog-title>Sync games supported in iOS devices</h1>
<mat-horizontal-stepper linear="true" #stepper>
  <mat-step [stepControl]="formGroup" [editable]="!done">
    <ng-template matStepLabel>Input games</ng-template>
    <h1 mat-dialog-title>Please insert csv file internal game codes of all games that are supported on iOS devices</h1>
    <form [formGroup]="formGroup" (submit)="processFile()">
      <app-form-field
        [type]="FILE_UPLOAD_TYPE"
        [editMode]="true"
        [fieldConfig]="fileConfig"
        [formGroup]="formGroup"></app-form-field>
      <div>
        <button mat-raised-button mat-dialog-close class="cancel-button">Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="formGroup.invalid || processing">
          Submit
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [editable]="!done">
    <ng-template matStepLabel>Summary</ng-template>
    <ngx-spinner></ngx-spinner>
    @if (summary) {
      <div class="summary-holder">
        <div>
          <h5>Games to add iOS support&nbsp;({{ summary.add.length }})</h5>
          <ul>
            @for (game of summary.add; track game) {
              <li class="game-name">{{ game.name }} ({{ game.studioName }})</li>
            }
          </ul>
        </div>
        <div>
          <h5>Games to remove iOS support&nbsp;({{ summary.remove.length }})</h5>
          <ul>
            @for (game of summary.remove; track game) {
              <li class="game-name">{{ game.name }} ({{ game.studioName }})</li>
            }
          </ul>
        </div>
        <div>
          <h5>Codes not found in the system&nbsp;({{ summary.notFound.length }})</h5>
          <ul>
            @for (code of summary.notFound; track code) {
              <li class="game-name">{{ code }}</li>
            }
          </ul>
        </div>
      </div>
    }
    <mat-accordion>
      <mat-expansion-panel class="mat-elevation-z0" hideToggle class="no-padding">
        <mat-expansion-panel-header class="no-padding">
          <mat-panel-title class="panel-title-holder">
            <mat-icon>list</mat-icon>
            <mat-label>See all games supported on iOS devices ({{ summary.allSupported.length }})</mat-label>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          @for (game of summary.allSupported; track game) {
            <li class="game-name">{{ game.name }} ({{ game.studioName }})</li>
          }
        </ul>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="actions-holder">
      <button mat-raised-button color="accent" matStepperPrevious class="action-button">Make changes</button>
      <button
        mat-raised-button
        color="primary"
        (click)="authorise()"
        [disabled]="summary.remove.length == 0 && summary.add.length == 0">
        Authorise
      </button>
    </div>
    @if (summary.remove.length == 0 && summary.add.length == 0) {
      <div class="info-holder">
        <i class="fas fa-exclamation-triangle" class="info-item"></i>File cannot be processed when there is nothing to
        sync!
      </div>
    }
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    <div class="success-info">Games have been synced successfully!</div>
    <div class="success-button">
      <button mat-raised-button color="primary" mat-dialog-close="">Close</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
